import { type EnvironmentProviders } from '@angular/core';
import { provideStates } from '@ngxs/store';
import { LocationState } from './states/location.state';

export function provideLocation(): EnvironmentProviders {
    return provideStates([LocationState]);
}
